import React, { useContext } from 'react'
import { Field, Form, Formik, FieldArray } from 'formik';
import ValidationError from '../Components/Errors/ValidationError';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import ReCAPTCHA from 'react-google-recaptcha';
import { VehicleContext } from '../Components/Context/VehicleContext';
import { useNavigate } from 'react-router-dom';

const ConsignmentAgreement = () => {
    const {submitContactForm} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();
    const navigate = useNavigate();
    UseScrollReveal()
    return (
        <>
            <section className='common-top-wrap ca-top-wrap pt-140'>
                <div className='container'>
                    <div className='ca-top-block d-flex align-items-center'>
                        <div className='w-100'>
                            <h4 className='xs-title fw-bold text-orange text-uppercase mt-0 wow reveal fadeIn'>Consignment Authorization</h4>
                            <h1 className='lg-title text-uppercase mt-3 wow reveal fadeIn'>Vehicle Consignment Agreement</h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className='common-wrap ca-wrap'>
                <div className='container'>
                    <h2 className='xs-title font-1-2em mb-4 wow reveal fadeIn'>Exclusive listing with the exclusive right to sell</h2>
                    <p className='wow reveal fadeIn'>(I) or (we), the undersigned, hereinafter, called the Consignor and McLaren Orlando, hereinafter, called the Consignee, agree as follows:</p>

                    <div className='xs-title my-4 text-orange text-uppercase wow reveal fadeIn'>Vehicle Info</div>
                    <Formik
                        // validationSchema={validationSchema}
                        initialValues={{
                            vehicle_year:'',
                            make:'',
                            model:'',
                            mileage:'',
                            engine:'',
                            transmission:'',
                            plate:'',
                            state:'',
                            style:'',
                            color:'',
                            vin:'',
                            clearTitle:'Yes',
                            other:'',
                            lienholder_name:'',
                            account_loan:'',
                            address:'',
                            payoff_valid_through:'',
                            per_diem_interest:'',
                            city:'',
                            payoff_estimate:'',
                            phone_number:'',
                            zip_code:'',
                            amount_owed_consignee:'',
                            approx_amount_consignee:'',
                            special_instructions:'',
                            any_known_defects:'',
                            any_information:'',
                            delivering_vehicle_consignee:'',
                            consignee_accepts_possession:'',
                            consignee_will_exercise:'',
                            agreement_is_effective:'',
                            consignor_warrants_represents_good:'',
                            all_monies_received:'',
                            which_shall_deducted:'',
                            consignor_warrants_represents:'',
                            unless_damage_caused:'',
                            should_consignor_wish:'',
                            on_delivery_vehicle:'',
                            maintenance_repair_vehicle:'',
                            consignor_promises_defend:'',
                            agreement_governed:'',
                            agreement_constitutes_entire_agreement:'',
                            special_note:'Yes',
                            initials_x:'',
                            consignor_first_name:'',
                            consignor_last_name:'',
                            consignor_address:'',
                            consignor_phone:'',
                            consignor_email:'',
                            consignor_city:'',
                            consignor_driver_license:'',
                            consignor_license_state:'',
                            consignor_state:'',
                            consignor_zip_code:'',
                            consignor_insurance_provider:'',
                            consignor_insurance_phone:'',
                            consignor_date:'',
                            consignor_policy_number:'',
                            consignor_names:'',
                            consignor_signature:'',
                            consignee_signature:'',
                            consignee_date:'',
                            consignee_vehicle_sold:'',
                            consignee_commission:'',
                            consignee_amount_due:'',
                            consignee_signature_of_owner:'',
                            consignee_if_not_sold:'',
                            consignee_vehicle_returen:'',
                            consignee_vehicle_returned:'',
                        }}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);
                            const data = await submitContactForm(values);

                            if (data.success) {
                                resetForm();
                                navigate("/thank-you");
                                // alert("Thank you for your submission. We'll be in touch soon!");
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ values, setFieldValue, field, form }) => (
                            <Form className="custom-form order-part-form" autoComplete="off" name="order-part-form">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                    size="invisible"
                                />
                                <div className='row gx-4'>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Vehicle Year</div>
                                            <Field
                                                as="select"
                                                name="vehicle_year"
                                                className="form-control"
                                            >
                                                <option value="">Select</option>
                                                <option value="2020">2020</option>
                                                <option value="2021">2021</option>
                                                <option value="2022">2022</option>
                                                <option value="2023">2023</option>
                                                <option value="2024">2024</option>
                                                <option value="2025">2025</option>

                                            </Field>
                                            <ValidationError name="vehicle_year" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Make</div>
                                            <Field
                                                as="select"
                                                name="make"
                                                className="form-control"
                                            >
                                                <option value="">Select</option>
                                                <option value="Toyota">Toyota</option>
                                                <option value="Ford">Ford</option>
                                                <option value="Honda">Honda</option>
                                                <option value="BMW">BMW</option>
                                                <option value="Hyundai">Hyundai</option>
                                            </Field>
                                            <ValidationError name="make" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Model</div>
                                            <Field
                                                as="select"
                                                name="model"
                                                className="form-control"
                                            >
                                                <option value="">Select</option>
                                                <option value="Camry">Camry</option>
                                                <option value="Corolla">Corolla</option>
                                                <option value="RAV4">RAV4</option>
                                                <option value="Highlander">Highlander</option>
                                                <option value="Prius">Prius</option>
                                            </Field>
                                            <ValidationError name="model" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Mileage</div>
                                            <Field
                                                type="text"
                                                name="mileage"
                                                className="form-control"
                                            />
                                            <ValidationError name="mileage" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Engine</div>
                                            <Field
                                                type="text"
                                                name="engine"
                                                className="form-control"
                                            />
                                            <ValidationError name="engine" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Transmission</div>
                                            <Field
                                                type="text"
                                                name="transmission"
                                                className="form-control"
                                            />
                                            <ValidationError name="transmission" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Plate</div>
                                            <Field
                                                type="text"
                                                name="plate"
                                                className="form-control"
                                            />
                                            <ValidationError name="plate" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>State</div>
                                            <Field
                                                as="select"
                                                name="state"
                                                className="form-control"
                                            >
                                                <option value="">Select</option>
                                                <option value="Camry">State 1</option>
                                                <option value="Corolla">State 2</option>
                                                <option value="RAV4">State 3</option>
                                            </Field>
                                            <ValidationError name="state" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Style</div>
                                            <Field
                                                type="text"
                                                name="style"
                                                className="form-control"
                                            />
                                            <ValidationError name="style" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Color</div>
                                            <Field
                                                type="text"
                                                name="color"
                                                className="form-control"
                                            />
                                            <ValidationError name="color" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>VIN</div>
                                            <Field
                                                type="text"
                                                name="vin"
                                                className="form-control"
                                            />
                                            <ValidationError name="vin" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1 d-none d-md-block'>&nbsp;</div>
                                            <div className='d-flex align-items-center mt-3'>
                                                <label className='xs-title me-3 mb-0 font-1em'>* Clear Title:</label>
                                                <div className='d-flex gap-3'>
                                                    <Field name='clearTitle'>
                                                        {({ field }) => (
                                                            <>
                                                                <div className='custom-radio'>
                                                                    <input
                                                                        type='radio'
                                                                        {...field}
                                                                        value='Yes'
                                                                        checked={field.value === 'Yes'}
                                                                        id="clearTitleYes"
                                                                    />
                                                                    <label htmlFor='clearTitleYes'>Yes</label>
                                                                </div>
                                                                <div className='custom-radio'>
                                                                    <input
                                                                        type='radio'
                                                                        {...field}
                                                                        value='No'
                                                                        checked={field.value === 'No'}
                                                                        id="clearTitleNo"
                                                                    />
                                                                    <label htmlFor='clearTitleNo'>No</label>
                                                                </div>
                                                            </>
                                                        )}
                                                    </Field>
                                                    <ValidationError name="clearTitle" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8 col-md-8 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Other</div>
                                            <Field
                                                type="text"
                                                name="other"
                                                className="form-control"
                                            />
                                            <ValidationError name="other" />
                                        </div>
                                    </div>
                                </div>
                                <div className='mb-3 mt-5 xs-title text-orange text-uppercase'>Lienholder Info</div>
                                <div className='row gx-4'>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Lienholder Name</div>
                                            <Field
                                                type="text"
                                                name="lienholder_name"
                                                className="form-control"
                                            />
                                            <ValidationError name="lienholder_name" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Account/Loan #</div>
                                            <Field
                                                type="text"
                                                name="account_loan"
                                                className="form-control"
                                            />
                                            <ValidationError name="account_loan" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Address</div>
                                            <Field
                                                type="text"
                                                name="address"
                                                className="form-control"
                                            />
                                            <ValidationError name="address" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Payoff Valid Through</div>
                                            <Field
                                                type="text"
                                                name="payoff_valid_through"
                                                className="form-control"
                                            />
                                            <ValidationError name="payoff_valid_through" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Per Diem Interest</div>
                                            <Field
                                                type="text"
                                                name="per_diem_interest"
                                                className="form-control"
                                            />
                                            <ValidationError name="per_diem_interest" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>City</div>
                                            <Field
                                                type="text"
                                                name="city"
                                                className="form-control"
                                            />
                                            <ValidationError name="city" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Payoff Estimate</div>
                                            <Field
                                                type="text"
                                                name="payoff_estimate"
                                                className="form-control"
                                            />
                                            <ValidationError name="payoff_estimate" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Phone Number</div>
                                            <Field
                                                type="text"
                                                name="phone_number"
                                                className="form-control"
                                            />
                                            <ValidationError name="phone_number" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>State</div>
                                            <Field
                                                as="select"
                                                name="lienholder_state"
                                                className="form-control"
                                            >
                                                <option value="">Select</option>
                                                <option value="Camry">State 1</option>
                                                <option value="Corolla">State 2</option>
                                                <option value="RAV4">State 3</option>
                                            </Field>
                                            <ValidationError name="lienholder_state" />
                                        </div>
                                    </div>
                                    <div className='col-lg-2 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Zip Code</div>
                                            <Field
                                                type="text"
                                                name="zip_code"
                                                className="form-control"
                                            />
                                            <ValidationError name="zip_code" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>After Payoff Aprox. Amount Owed to Consignee</div>
                                            <Field
                                                type="text"
                                                name="amount_owed_consignee"
                                                className="form-control"
                                            />
                                            <ValidationError name="amount_owed_consignee" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Or Approx Amount Consignee Owes McLaren Orlando</div>
                                            <Field
                                                type="text"
                                                name="approx_amount_consignee"
                                                className="form-control"
                                            />
                                            <ValidationError name="approx_amount_consignee" />
                                        </div>
                                    </div>
                                </div>
                                <hr className='cs-hr' />
                                <div className='row gx-5'>
                                    <div className='col-md-6 col-12 mb-3'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Please list any special instructions regarding this vehicle I.E. starting procedure, driving issues or anything that needs to be explained upon driving or moving this vehicle (includes test drives):</div>
                                            <Field
                                                as="textarea"
                                                name="special_instructions"
                                                className="form-control h-120"
                                            />
                                            <ValidationError name="special_instructions" />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12 mb-3'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Please list any known defects, flaws or damage this car has now. Also list any maintenance this vehicle may need:</div>
                                            <Field
                                                as="textarea"
                                                name="any_known_defects"
                                                className="form-control h-120"
                                            />
                                            <ValidationError name="any_known_defects" />
                                        </div>
                                    </div>
                                    <div className='col-12 mb-3'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Please list any information that will enable potential buyers to make a well informed decision on your vehicle I.E. Restoration done, work performed, modifications made, vehicle history, receipts, how long you have owned this vehicle, why selling (opt) etc. *This info will also be used in advertising your vehicle so the more information you can provide the better.</div>
                                            <Field
                                                as="textarea"
                                                name="any_information"
                                                className="form-control h-120"
                                            />
                                            <ValidationError name="any_information" />
                                        </div>
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>2. By delivering the vehicle to Consignee, you are placing it on consignment with Consignee for one month. This Agreement is not a sale of the Vehicle to Consignee. Consignor hereby tenders to Consignee $350.00, which represents a non-refundable one-month fee for advertising expenses, clean-up, handling and storage. Initials X.</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="delivering_vehicle_consignee"
                                            className="form-control"
                                        />
                                        <ValidationError name="delivering_vehicle_consignee" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>3.Consignee accepts possession of Consignors vehicle for consignment and will list the vehicle at a n initial sale price of (“List Price”):$</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="consignee_accepts_possession"
                                            className="form-control"
                                        />
                                        <ValidationError name="consignee_accepts_possession" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>Consignee will exercise all commercially reasonable efforts to sell the vehicle for the List Price and Consignee is authorized to sell the vehicle for the List Price or a higher amount, without further authorization from Consignor. In addition, Consignor and will present all bona fide offers to purchase to Consignor within forty-eight (48) hours of Consignee’s receipt of the same. The written consent of Consignor is required for any sale that is less than the List Price, which may be delivered to Consignee by text message, e-mail, or other written communication. Initials X:$</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="consignee_will_exercise"
                                            className="form-control"
                                        />
                                        <ValidationError name="consignee_will_exercise" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>This Agreement is effective, valid, and binding for thirty (30) days from the date that the Agreement is signed by Consignee and Consignor. If the vehicle is not sold within thirty (30) days of execution of this Agreement, Consignee shall return the vehicle to Consignor or enter into a new consignment agreement related thereto. If Consignor takes possession of the vehicle at the expiration of this Agreement, Consignee reserves the right to charge a new non-refundable fee in the amount of $350.00 upon execution of the subsequent consignment Agreement. InitialsX</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="agreement_is_effective"
                                            className="form-control"
                                        />
                                        <ValidationError name="agreement_is_effective" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>4. Consignor warrants and represents that it has good title to vehicle and will provide proof of title to Consignee. Consignee must be able to show that the title is free and clear from all claims and liens or that the lienholder will cooperate with any sale made and release lien in a timely manner. Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="consignor_warrants_represents_good"
                                            className="form-control"
                                        />
                                        <ValidationError name="consignor_warrants_represents_good" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>5. All monies received by Consignee shall be the property of the Consignor. Consignee shall be able to collect deposits from buyers toward the purchase of the vehicle. Consignor agrees that the Consignee may deduct acommission in the amount of $</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="all_monies_received"
                                            className="form-control"
                                        />
                                        <ValidationError name="all_monies_received" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>which shall be deducted from the final selling price immediately upon sale of the vehicle. In this agreement, a "sale" occurs when the Consignee: (A) receives the List Price or the agreed upon sales price or its equivalent, or executes a conditional sales contract for the vehicle, or (B) when the purchaser takesdelivery of the vehicle, whichever comes first. Within 20 days after the sale, the Consignee shall make an accounting to the Consignor of all of the following: date of sale, repairs authorized by the Consignor (supported by work records), and the total sales price. Upon payment to the monies due the Consignor, the Consignor agrees to furnish the dealer all documents necessary to transfer the ownership of the vehicle to the purchaser including clear title and any lien release documentation. *If the Consignee finds a buyer for the subject vehicle and the Consignor circumvents or goes around the Consignee in an attempt to avoid payment for the commission to Consignee, by selling to the customer developed by the Consignee, this will be treated as a sale and the above commission will be due and payable to the Consignee. A sale by or on behalf of the Consignor to any person, firm or entityother than the Consignee, during the duration of this Agreement with or without assistance of the Consignee will also be treated as a sale and the above commission will be due and payable. Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="which_shall_deducted"
                                            className="form-control"
                                        />
                                        <ValidationError name="which_shall_deducted" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>6. Consignor warrants and represents that the vehicle is covered by a valid and active automobile liability insurance policy that meets the requirements of the North Carolina Financial Responsibility Act or, if registered outside the State of North Carolina, the minimum insurance requirements in the State in which the vehicle is registered. Consignor also warrants and represents that the licenses plate on the vehicle is valid, that valid insurance will remain on the vehicle during the term of this Agreement, and that Consignor’s plates will remain on the vehicle while in the possession of Consignee. Consignor acknowledges and understands that the automotive liability insurance policy covering the vehicle, and listed on page 1 of this Agreement, shall provide primary insurance coverage for any loss or damage occurring during the term of this Agreement. Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="consignor_warrants_represents"
                                            className="form-control"
                                        />
                                        <ValidationError name="consignor_warrants_represents" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>7. Unless damage is caused by the negligence or gross negligence of Consignee, Consignor is solely responsible for the vehicle while in the possession of Consignee and shall hold Consignee harmless from any and all damages or loss to the Vehicle that may occur while vehicle is in Consignee's possession. Consignor is responsible for the vehicle for any damage or accidents that may occur during the term of this Agreement unless such damage or accident is caused by the negligence or gross negligence of Consignee. Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="unless_damage_caused"
                                            className="form-control"
                                        />
                                        <ValidationError name="unless_damage_caused" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>8. Should Consignor wish to remove the vehicle from Consignees premises, Consignor shall deliver 3 days’ notice to Consignee and the vehicle can then be removed from Consignee’s possession between 10:00 am and 6:00 pm weekdays or upon set appointment.Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="should_consignor_wish"
                                            className="form-control"
                                        />
                                        <ValidationError name="should_consignor_wish" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>9. On delivery of the vehicle to Consignee, Consignor shall produce evidence of ownership of the vehicle which shallbe held by Consignee while the vehicle is in Consignee's possession. Consignor shall provide adequate documentation and proof of ownership so that the Consignee may complete a sale to the buyer. The consigned vehicle is delivered to the dealer in trust for the exact terms set forth in the Agreement. The Consignee agrees to receive this vehicle in trust and not to permit its use for any other purpose than what is contained in this Agreement without the express written consent of the Consignor.Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="on_delivery_vehicle"
                                            className="form-control"
                                        />
                                        <ValidationError name="on_delivery_vehicle" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>10. The maintenance and repair of the vehicle shall be at the sole expense of the Consignor. If mechanical or maintenance work becomes necessary while the vehicle is on the Consignee's premises, Consignee will seek permission from Consignor to complete the necessary repairs. If Consignor refuses to authorize completion of necessary repairs recommended by Consignee, Consignee may terminate this Agreement and return possession of the vehicle to Consignor. In such case, Consignee is authorized to retain the non-refundable fee identified in Paragraph 2 above.Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="maintenance_repair_vehicle"
                                            className="form-control"
                                        />
                                        <ValidationError name="maintenance_repair_vehicle" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>11. Consignor hereby promises to defend, indemnify and hold harmless Consignee, its employees, agents andaffiliates from any and all demands, judgments, claims, including reasonable legal and all other expenses, actually incurred and paid, incident to any claim whether baseless or well founded by any third party in connection with any use or sale of the automobile taken by Consignee on consignment, including without limitation any claim for taxes by any state of the United States, territory or political subdivision thereof. The indemnification language contained in this agreement shall survive the termination of the agreement.Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="consignor_promises_defend"
                                            className="form-control"
                                        />
                                        <ValidationError name="consignor_promises_defend" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>12. This Agreement is governed by and shall be construed in accordance with North Carolina law. By their signatures below, Consignor and Consignee mutual agree that any and all disputes related to this Agreement shall be resolved exclusively within the North Carolina State Courts sitting in Mecklenburg County, North Carolina. Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="agreement_governed"
                                            className="form-control"
                                        />
                                        <ValidationError name="agreement_governed" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>13. This Agreement constitutes the entire agreement between the parties pertaining to the subject matter contained in it and supersedes any prior and contemporaneous agreements, representations and understandings of the parties. No supplement, modification or amendments of this agreement shall be binding unless it is executed in writing by each of the parties. No waiver of any of the provisions of this agreement shall be deemed or shall constitute a waiver of any other provision, whether or not similar, nor shall any waiver constitute a continuing waiver. No waiver shall bebinding unless executed in writing by the party making the waiver.Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="agreement_constitutes_entire_agreement"
                                            className="form-control"
                                        />
                                        <ValidationError name="agreement_constitutes_entire_agreement" />
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>SPECIAL NOTE: If a buyer chooses to use a credit card to purchase Consignor's vehicle there will be an additional 2% deducted from selling price. Are you willing to accept a credit card payment if necessary?</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <div className='d-flex gap-3'>
                                            <Field name='special_note'>
                                                {({ field }) => (
                                                    <>
                                                        <div className='custom-radio'>
                                                            <input
                                                                type='radio'
                                                                {...field}
                                                                value='Yes'
                                                                checked={field.value === 'Yes'}
                                                                id='specialNoteYes'
                                                            />
                                                            <label htmlFor='specialNoteYes'>Yes</label>
                                                        </div>
                                                        <div className='custom-radio'>
                                                            <input
                                                                type='radio'
                                                                {...field}
                                                                value='No'
                                                                checked={field.value === 'No'}
                                                                id='specialNoteNo'
                                                            />
                                                            <label htmlFor='specialNoteNo'>No</label>
                                                        </div>
                                                    </>
                                                )}
                                            </Field>
                                            <ValidationError name="special_note" />
                                        </div>
                                    </div>
                                </div>
                                <div className='row gx-5 mb-4'>
                                    <div className='col-lg-8 col-12 pe-80'>
                                        <div className='cs-label mb-1'>Initials X</div>
                                    </div>
                                    <div className='col-lg-4 col-12'>
                                        <Field
                                            type="text"
                                            name="initials_x"
                                            className="form-control"
                                        />
                                        <ValidationError name="initials_x" />
                                    </div>
                                </div>
                                <div className='mb-3 mt-5 xs-title text-orange text-uppercase'>CONSIGNOR</div>

                                <div className='row gx-5'>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>First Name</div>
                                            <Field
                                                type="text"
                                                name="consignor_first_name"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_first_name" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Last Name</div>
                                            <Field
                                                type="text"
                                                name="consignor_last_name"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_last_name" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Address</div>
                                            <Field
                                                type="text"
                                                name="consignor_address"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_address" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Phone</div>
                                            <Field
                                                type="text"
                                                name="consignor_phone"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_phone" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Email</div>
                                            <Field
                                                type="text"
                                                name="consignor_email"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_email" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>City</div>
                                            <Field
                                                type="text"
                                                name="consignor_city"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_city" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Driver License #</div>
                                            <Field
                                                type="text"
                                                name="consignor_driver_license"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_driver_license" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>License State</div>
                                            <Field
                                                type="text"
                                                name="consignor_license_state"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_license_state" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='row gx-4'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='cs-label mb-1'>State</div>
                                                    <Field
                                                        as="select"
                                                        name="consignor_state"
                                                        className="form-control"
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Camry">State 1</option>
                                                        <option value="Corolla">State 2</option>
                                                        <option value="RAV4">State 3</option>
                                                    </Field>
                                                    <ValidationError name="consignor_state" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='cs-label mb-1'>Zip Code</div>
                                                    <Field
                                                        type="text"
                                                        name="Zip Code"
                                                        className="form-control"
                                                    />
                                                    <ValidationError name="consignor_zip_code" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Insurance Provider</div>
                                            <Field
                                                type="text"
                                                name="consignor_insurance_provider"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_insurance_provider" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Insurance Phone</div>
                                            <Field
                                                type="text"
                                                name="consignor_insurance_phone"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_insurance_phone" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Date</div>
                                            <Field
                                                type="text"
                                                name="consignor_date"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_date" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Policy Number</div>
                                            <Field
                                                type="text"
                                                name="consignor_policy_number"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_policy_number" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Names</div>
                                            <Field
                                                type="text"
                                                name="consignor_names"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_names" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Cosignor(s) Signature</div>
                                            <Field
                                                type="text"
                                                name="consignor_signature"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignor_signature" />
                                        </div>
                                    </div>
                                </div>
                                <h4 className='mb-2 mt-5 xs-title text-orange text-uppercase'>CONSIGNEE</h4>
                                <h2 className='xs-title font-1-2em fw-bold'>McLaren Orlando LLC</h2>
                                <p className='mb-3'>1111 S Orlando Ave <br/>
                                Winter Park, FL 32789</p>
                                <div className='row gx-5'>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Consignee(s) Signature</div>
                                            <Field
                                                type="text"
                                                name="consignee_signature"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignee_signature" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Date</div>
                                            <Field
                                                type="text"
                                                name="consignee_date"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignee_date" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>If Sold Vehicle Sold for $</div>
                                            <Field
                                                type="text"
                                                name="consignee_vehicle_sold"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignee_vehicle_sold" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Consignee Commission $</div>
                                            <Field
                                                type="text"
                                                name="consignee_commission"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignee_commission" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Amount Due to Consignor after Commissions $</div>
                                            <Field
                                                type="text"
                                                name="consignee_amount_due"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignee_amount_due" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>Signature(s) of Owner(s) Consignor’s First and Last Name</div>
                                            <Field
                                                type="text"
                                                name="consignee_signature_of_owner"
                                                className="form-control"
                                            />
                                            <ValidationError name="consignee_signature_of_owner" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>If Not Sold: Vehicle was returen to owner on</div>
                                            <Field
                                                type="text"
                                                name="consignee_vehicle_returen"
                                                className="form-control"
                                            />
                                            <div className='cs-label mt-1'>and consignment agreement is hereby terminated</div>
                                            <ValidationError name="consignee_vehicle_returen" />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-12'>
                                        <div className='form-group'>
                                            <div className='cs-label mb-1'>If not sold: Vehicle was returned to owner on</div>
                                            <Field
                                                type="text"
                                                name="consignee_vehicle_returned"
                                                className="form-control"
                                            />
                                            <div className='cs-label mt-1'>and consignment agreement is hereby terminated</div>
                                            <ValidationError name="consignee_vehicle_returned" />
                                        </div>
                                    </div>
                                </div>
                                <div className='text-md-end text-center mt-90 mb-5'>
                                    <button type='submit' className='theme-btn text-uppercase d-inline-block w-320'>
                                        Send
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </section>
        </>
    )
}

export default ConsignmentAgreement